import * as _ from "lodash";
import * as angular from "angular";
import { Filter } from "../../models/filter.model";
import { Organisation } from "../../models/organisation.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { User } from "../../models/user.model";
import { FilterDataProvider } from "../../data-provider/filter.dp";

let OrganisationUsersComponent = {
    selector: "vcOrganisationUsers",
    templateUrl: "/angular/components/organisation-user/users.component.html",
    bindings: {
        activeOrganisation: "=?",
    },
    controller: class OrganisationUsersController {
        // * bindings for typescript compiler *
        public activeOrganisation?: Organisation;
        // ************************************

        private $scope: any;
        private organisationUserDataProvider: OrganisationUserDataProvider;
        private localStorageService: any;
        private $location: any;
        private dialog: DialogUtils;
        public navigationBarService: NavigationBarHelperService;

        public permissionProvider: PermissionCheck;
        public selected: Array<any> = [];
        public showTable: boolean = true;
        public scrollLoading: boolean = false;
        public loadingData: boolean = false;
        public filter: Filter = new Filter({
            search: { values: "", checked: true },
        });
        public filterDataProvider: FilterDataProvider;
        public active_view: string = "users";
        public headlineStats: any;
        public columns: any;
        public search: any;
        public active_tab: string;
        public showSearch: boolean;
        public isLeaderView: boolean;
        public signedInUser: User;

        constructor(
            $scope: any,
            __app_type: string,
            $location: any,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            UserDataProvider: UserDataProvider,
            localStorageService: any,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            FilterDataProvider: FilterDataProvider
        ) {
            this.$scope = $scope;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.permissionProvider = PermissionCheck;
            this.dialog = DialogUtils;
            this.localStorageService = localStorageService;
            this.$location = $location;
            this.columns = this.organisationUserDataProvider.getColumns();
            this.search = this.$location.search();
            this.active_tab = this.search.tab ? this.search.tab : "users";
            this.navigationBarService = NavigationBarHelperService;
            this.filterDataProvider = FilterDataProvider;
            this.filterDataProvider.setPage("org_users");
            this.filter = this.filterDataProvider.appliedFilter;

            this.organisationUserDataProvider.headlineStats().then((stats) => {
                this.headlineStats = stats;
            });
            this.isLeaderView = __app_type == "LEADER";
            this.signedInUser = UserDataProvider.getActiveUser();
        }

        tabChanged(tab: string): void {
            this.active_tab = tab;
            this.$location.search("tab", tab);

            if (tab === "map") {
                this.filterDataProvider.filter.permission = {
                    values: [],
                    checked: false,
                };
                this.filter.permission = { values: [], checked: false };
                this.$location.search(
                    "filter",
                    JSON.stringify(this.filter.nonEmptyValues())
                );
            }
        }

        toggleSearch(): void {
            this.showSearch = !this.showSearch;
            if (!this.showSearch) {
                this.filter.search.values = "";
            }
        }

        openColumnsDialog(columns: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-columns-dialog",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    ariaLabel: "Change User Assigned to this follow-up request",
                    class: "columns-dialog",
                    locals: {
                        columns: columns,
                        sortable: false,
                    },
                })
                .then((columns: any) => {
                    _.merge(this.columns, columns);
                    this.localStorageService.set(
                        "organisationUserColumns",
                        this.columns
                    );
                });
        }

        organisationInvite(activeOrganisation: Organisation, ev: any): void {
            this.dialog.show({
                component: "vc-leader-invite",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    organisation: activeOrganisation,
                },
                size: "large",
            });
        }
        showInvites(): boolean {
            const signedInUser = this.signedInUser;
            return (
                signedInUser &&
                (signedInUser.account_type === "ADMIN" ||
                    signedInUser.permission.permissionid !== 10)
            );
        }
    },
};

angular
    .module("organisationUser")
    .component(OrganisationUsersComponent.selector, OrganisationUsersComponent);
